import { createSelector } from '@reduxjs/toolkit';
import ASYNC_STATE from '../../../constants/AsyncState';
import { toIsLoading } from '../../../helper/reduxLoadingStatusHelper';
import { currentPaginationEntities, toPaginationPaginationResult } from '../../../helper/reduxPaginationHelper';

export const getAllTenants = (state) => state.tenants.tenants;
export const getSelectedTenantId = (state) => state.tenants.selectedTenantId;

export const getSelectedTenant = createSelector(
  [getSelectedTenantId, getAllTenants],
  (tenantId, tenants) => tenants[tenantId],
);

const getTenantsState = (state) => state.tenants.fetch || {};

export const getTenants = createSelector([getTenantsState, getAllTenants], currentPaginationEntities);

export const getTenantsPaginationResult = createSelector([getTenantsState], toPaginationPaginationResult);

export const getTenantsLoading = createSelector([getTenantsState], toIsLoading);

export const getSelectedTenantLoading = (state) => state.tenants.fetchTenantDetails.status === ASYNC_STATE.LOADING;

export const getTenantSelectOptions = (state) => state.tenants.tenantSelectOptions;
